jQuery(document).ready(function($) {
  if ($.fn.counterUp) {
    $('.counter').counterUp({
      time: 1000,
      delay: 16
    });
  } else {
    console.warn("counterUp plugin not found");
  }
 // * ================== START : Drawer menu close Trigger JS *=================================
  $(document).on("click", ".menu-icon-close", function () {
    $("body").find(".header__icon--menu").trigger("click");
  });
 // * ================== END : Drawer menu close Trigger JS *=================================

 // * ================== START : Add Class On Body JS *=================================
  $(document).on("click", ".header__icon--menu", function () {
    $("body").toggleClass("menu-drawer-open");
  });

 // * ================== END : Add Class On Body JS *=================================


 // * ================== START : Header Drawer Toggle JS *=================================
   $('.menu-drawer__menu details').on('toggle', function () {
    if (this.open) {
      $('.menu-drawer__menu details').not(this).removeAttr('open');
    }
  });
 // * ================== END : Header Drawer Toggle JS *=================================
  
  // * ================== START : Header Drawer Toggle JS *=================================
    if($(".new-pdp-template").length > 0 && $(".pdp-atc-price").length > 0){
      $(document).on("click", ".product__info-wrapper variant-selects label", function () {
        setTimeout(function () {
          var selectedPrice = $(".pdp-price-block .price").attr("data-price");
          $(".pdp-atc-price > span").text(selectedPrice);
          // Show/hide based on hidden class
          if ($(".pdp-price-block").hasClass("hidden")) {
            $(".pdp-atc-price > span").hide();
          }
          else{
             $(".pdp-atc-price > span").show();
          }
        }, 800);
      });
    }
  // * ================== END : Header Drawer Toggle JS *=================================

  // * ================== START : Shipping Method Variant Visibility *=================================
  $('input[name*="Quantity"] + label').css('text-decoration', 'none');
      $(document).on('change', 'input[name*="Shipped from"], input[name*="SHIPPED FROM"]', function() {
      $('input[name*="Shipped from"], input[name*="SHIPPED FROM"]').prop('disabled', false).removeClass('disabled').next('label').css('text-decoration','none');
      // remove disabled class from all quantity options
      $('input[name*="Quantity"]').removeClass('disabled');
      $('input[name*="Option-2"]').removeClass('disabled');
      const selectedShipping = $(this).val();
      let quantityOptions = $('input[name*="Quantity"]')
      if (!quantityOptions.length) {
        quantityOptions = $('input[name*="Option-2"]');
      }
       if (selectedShipping === 'Buy with Prime') {
         $('input[data-shipped-from="fiber-gourmet"]').addClass('disabled').next('label').hide();
         $('input[data-shipped-from="buy-with-prime"]').removeClass('disabled').next('label').show();
         $('.product-form__submit').hide();
         $('#amzn-buy-now').show();
       } else {
         $('input[data-shipped-from="buy-with-prime"]').addClass('disabled').next('label').hide();
         $('input[data-shipped-from="fiber-gourmet"]').removeClass('disabled').next('label').show();
         $('.product-form__submit').show();
         $('#amzn-buy-now').hide();
                }
      // If a valid quantity is already selected, do nothing
      const $currentQty = $('input[name*="Quantity"], input[name*="Option-2"]').filter(':checked');
      if ($currentQty.length && !$currentQty.hasClass('disabled') && $currentQty.next('label').is(':visible')) return;
      // Force-select a valid quantity to apply filtering immediately
      $('input[name*="Quantity"], input[name*="Option-2"]').not('.disabled').first().next('label').trigger('click');
      
    });
  // Re-apply after Shopify re-renders on variant change
  subscribe(PUB_SUB_EVENTS.variantChange, () => $('input[name*="Shipped from"], input[name*="SHIPPED FROM"]').filter(':checked').trigger('change'));
  // Apply on load (default Fiber Gourmet if none selected)
  const $ship = $('input[name*="Shipped from"], input[name*="SHIPPED FROM"]');
  const __qs = new URLSearchParams(window.location.search);
  if (__qs.get('utm_source') === 'bwp-elements') {
    $ship.filter((_, el) => /Prime/i.test(el.value)).first().prop('checked', true);
  }
  $ship.filter(':checked').trigger('change');
  // * ================== END : Shipping Method Variant Visibility *=================================




var interval = setInterval(function () {
  if ($('.spurit-ros__widget').length > 0) {
    clearInterval(interval);

    // START: Update subscription title
    function updateSubscriptionText() {
      var subscriptionText = $('.spurit-ros__subscribe-option').next('.spurit-ros__option-inner').find('.spurit-ros__label-text');
      if (subscriptionText.length) {
        subscriptionText.text('Subscribe & Save');
      }
    }
    
    updateSubscriptionText();
    
    $(document).on('change', '.spurit-ros__option input', function () {
      updateSubscriptionText();
    });
   // END: Update subscription title

    //Append Html
    var customDiv = `
      <div class="custom-benefits">
        <div class="benefit-item">
          Pause, Skip or cancel anytime
        </div>
        <div class="benefit-item">
          Free Shipping
        </div>
        <div class="benefit-item">
          Never run out of your pasta stock
        </div>
      </div>
    `;

    $('.spurit-ros__option-content-wrap').after(customDiv);
    
    // START: Prefix select option text with label text
    $('.spurit-ros__frequencies').each(function () {
      var $wrapper = $(this);
      var labelText = $wrapper.find('label').text().trim();
      var $select = $wrapper.find('.spurit-ros__frequency_select__wrapper select');

      $select.find('option').each(function () {
        var originalText = $(this).text().trim();
        if (!originalText.startsWith(labelText)) {
          $(this).text(labelText + ' - ' + originalText);
        }
      });
    });
    // END: Prefix select option text
  }
}, 100);



});